import {
  NavigationEnd,
  Router,
  RouterEvent,
  RouterLink,

} from '@angular/router';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild,
  Renderer2,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { DatePipe, JsonPipe, NgClass, NgFor, NgIf } from '@angular/common';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  FormArray,
} from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader'; // Import NgxUiLoaderService
import {
  BsModalService,
  BsModalRef,
  ModalOptions,
  ModalDirective,
} from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { CalendarService } from 'src/app/services/api/consumer/calendar.service';

@Component({
  selector: 'app-quick-availability-update',
  standalone: true,
  imports: [NgIf],
  templateUrl: './quick-availability-update.component.html',
  styleUrl: './quick-availability-update.component.scss'
})
export class QuickAvailabilityUpdateComponent {
  constructor(
    private ngxService: NgxUiLoaderService,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private _router: Router,
    private renderer: Renderer2,
    private router: Router,
    private CalendarService: CalendarService
  ) { }
  ngOnInit(): void {
  }
  @ViewChild('quickAvailabilityModal') quickAvailabilityModal: any;
  @Input() stats: any;
  @Output() availabilityUpdated = new EventEmitter<void>();

  updateQuickAvailability() {
    this.ngxService.start();
    let data = {
      status: 'A',
    }
    this.CalendarService.updateQuickAvailabilityAPI(
      data
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.bsModalRef.hide();
          this.availabilityUpdated.emit(); // Notify parent
          // this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }
  closeModal() {
    this.bsModalRef.hide();
  }
  // Circular progress ring
  getSmallProfileDashOffset(availability_health: number): string {
    const r = 35;
    const circumference = 2 * Math.PI * r;
    const adjustedHealth = 100 - availability_health;
    const percent = Math.max(0, Math.min(100, adjustedHealth));
    const offset = circumference - (circumference * percent) / 100;
    return offset.toFixed(3);
  }

  getSmallProfileDashArray(availability_health: number): string {
    const r = 35;
    return (2 * Math.PI * r).toFixed(3);
  }
  openQuickAvailabilityModal() {
    this.bsModalRef = this.modalService.show(this.quickAvailabilityModal, {
      class: 'modal-md',
      backdrop: 'static',
    });
  }
}
